import {
  InsuranceMonitor,
  InsuranceMonitorJobStatus,
  SharedFileRequestJobStatus
} from "@wingspanhq/wingspan-api-sdk";
import startCase from "lodash/startCase";

import { ValidationItemProps } from "../../../../components/AIValidationWidget/ValidationItem";

const JOB_STATUSES: Record<
  InsuranceMonitorJobStatus,
  SharedFileRequestJobStatus
> = {
  [InsuranceMonitorJobStatus.PENDING]: SharedFileRequestJobStatus.PENDING,
  [InsuranceMonitorJobStatus.COMPLETE]: SharedFileRequestJobStatus.COMPLETE,
  [InsuranceMonitorJobStatus.FAILED]: SharedFileRequestJobStatus.FAILED
};

/**
 * The per-policy validation results shown in the AI validation widget.
 *
 * These used to be recomputed in the browser against the monitor's inline
 * requirement config, which could only ever compare a single coverage amount.
 * SDK 3.13.0's `InsuranceMonitor.jobs` carries the server's own result per
 * required policy type — including which limit, provision or date missed in
 * `statusReason` — so the checks are read rather than re-derived, and
 * per-limit failures now surface accurately.
 *
 * `jobs` is empty until matching has run, which renders as no items.
 */
export const getInsuranceMonitorValidationItems = (
  monitor: InsuranceMonitor
): ValidationItemProps[] =>
  (monitor.jobs ?? []).map(job => ({
    title: job.title || startCase(job.policyType) || "Policy check",
    description: job.description,
    type: job.policyType,
    status: job.status
      ? JOB_STATUSES[job.status]
      : SharedFileRequestJobStatus.PENDING,
    statusReason: job.statusReason ?? undefined
  }));
